import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { useEffect } from 'react';
import { z } from 'zod';

import { AssetPage } from '@/components/Pages/AssetPage';
import { useAnalytics } from '@/hooks/useAnalytics';
import { searchParam } from '@/utils/router';

const pageSearchSchema = z.object({
  branchId: searchParam().optional(),
  versionId: searchParam().optional(),
});

export const Route = createFileRoute('/$organizationName/cb/$codebaseId/autodocs/page/$pageVersionNodeId')({
  component: Page,
  validateSearch: zodValidator(pageSearchSchema),
});

function Page() {
  const { captureEvent } = useAnalytics();
  const { organizationName, codebaseId, pageVersionNodeId } = Route.useParams();
  const { branchId, versionId } = Route.useSearch();

  useEffect(() => {
    captureEvent('autodoc_page_viewed', { codebase_id: codebaseId, page_version_node_id: pageVersionNodeId });
  }, [captureEvent, codebaseId, pageVersionNodeId]);

  const backSearch =
    branchId || versionId ? { ...(branchId ? { branchId } : {}), ...(versionId ? { versionId } : {}) } : undefined;

  return (
    <AssetPage
      pageVersionNodeId={pageVersionNodeId}
      backTo="/$organizationName/cb/$codebaseId/autodocs"
      backParams={{ organizationName, codebaseId }}
      backSearch={backSearch}
    />
  );
}
